import { FormWidget } from '../../../editor/features/build/requestModels/widgets/FormWidget/FormWidget';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';

export const useFormWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = async (dialogueId: number, sortOrder: number) => {
    const newWidget = FormWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    addNew,
    update: commonWidgetHandlers.update,
    delete: commonWidgetHandlers.delete,
  };
};
